import { z } from 'zod';
import { type TranslationKey } from '@/i18n/translation-key';

export const updateMediaSchemaFactory = (t: (key: TranslationKey) => string) => {
  return z.object({
    title: z.string().min(2, t('media.validation.titleMinLength')).optional(),
  });
};
